/**
 * Checks whether given string value is empty or not
 * @param value Value of string type
 * @returns Returns true if given value is empty otherwise false
 */
 export function IsEmpty(value: string): boolean {
   
    if(value == null || value == "" || value == undefined || value == "undefined" || value.trim().length == 0)
    {
        return true;
    }
    else
        return false; 
}

export function NullToString(value: string): string {
   
    if(value == null || value == "" || value == undefined || value.trim().length == 0)
    {
        return "";
    }
    else
        return value; 
}